import { render } from "./Incomes.vue?vue&type=template&id=17838c52&scoped=true"
import script from "./Incomes.vue?vue&type=script&lang=js"
export * from "./Incomes.vue?vue&type=script&lang=js"

import "./Incomes.vue?vue&type=style&index=0&id=17838c52&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17838c52"]])

export default __exports__